import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import cn from 'classnames';
import * as styles from '../../shared_mobile_styles.css';
import { AddressInput } from '../../../AddressInput';
import { RoomsCountSelector } from '../../../RoomsCountSelector';
import { FilterWithButtonGroup } from '../../../packages/FilterWithButtonGroup';
import { Label } from '../../../Label';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var JKMobile = function JKMobile(props) {
  return /*#__PURE__*/_jsx("div", {
    className: styles['container'],
    children: /*#__PURE__*/_jsx("div", {
      className: cn(styles['paper'], props.isEmbedded && styles['embedded']),
      children: /*#__PURE__*/_jsx("form", {
        className: styles['form'],
        onSubmit: function onSubmit(e) {
          return e.preventDefault();
        },
        children: /*#__PURE__*/_jsxs("div", {
          className: styles['form-content'],
          children: [/*#__PURE__*/_jsx("div", {
            className: cn(styles['form-content-address'], styles['form-content-item']),
            children: /*#__PURE__*/_jsx(FilterWithButtonGroup, _objectSpread(_objectSpread({}, props.estimationTargetProps), {}, {
              testId: "estimation_target_control"
            }))
          }), /*#__PURE__*/_jsxs("div", {
            className: cn(styles['form-content-address'], styles['form-content-item']),
            children: [/*#__PURE__*/_jsx(Label, {
              label: "\u0410\u0434\u0440\u0435\u0441 \u0438\u043B\u0438 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0416\u041A"
            }), /*#__PURE__*/_jsx(AddressInput, _objectSpread({
              className: styles['form-content-fixed-height']
            }, props.addressProps))]
          }), /*#__PURE__*/_jsxs("div", {
            className: styles['form-content-item'],
            children: [/*#__PURE__*/_jsx(Label, {
              label: "\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u043E\u043C\u043D\u0430\u0442"
            }), /*#__PURE__*/_jsx(RoomsCountSelector, _objectSpread({
              className: styles['form-content-fixed-height']
            }, props.jkRoomsCountSelectorProps))]
          })]
        })
      })
    })
  });
};
JKMobile.displayName = 'JKMobile';